// @flow
import React from 'react';
import actionTypes from '../../store/payment/actionTypes';
import styles from './styles.module.scss';
import { Button } from '../../components';
import ButtonPayPal from '../../components/ButtonPayPal';
import { RATE_NAME, PRICE_KEY } from '../../constants/payments';
import { gtmPayment } from 'utils/gtm/gtmPayment';

type CheckedPayment = {
  paypal: boolean,
  stripe: boolean,
}

export default (rateName: string, checkedPayment: CheckedPayment, stripe, dispatch) => {
  const customerEmail = localStorage.getItem('email');
  const handlerStripe = (price: string) => dispatch({
    type: actionTypes.GET_STRIPE_SESSION,
    payload: { price, stripe },
  });

  const buttonStrip = (onClick: (any) => void) => (
    <Button
      className={styles.button}
      name="PROCEED TO CHECKOUT"
      onClick={onClick}
    />
  );

  const buttonPaypal = (type: string) => {
    if (!customerEmail) return null;
    return <ButtonPayPal type={type} user={customerEmail || ''} />;
  };

  const { paypal, stripe: _stripe } = checkedPayment;

  if (rateName === RATE_NAME.PLO4) {
    if (paypal) {
      return buttonPaypal(RATE_NAME.PLO4);
    }

    if (_stripe) {
      return buttonStrip(() => handlerStripe(PRICE_KEY.PLO4));
    }
  }

  if (rateName === RATE_NAME.PLO5) {
    if (paypal) {
      return buttonPaypal(RATE_NAME.PLO5);
    }

    if (_stripe) {
      return buttonStrip(() => handlerStripe(PRICE_KEY.PLO5));
    }
  }

  if (rateName === RATE_NAME.PLO4PLO5) {
    if (paypal) {
      return buttonPaypal(RATE_NAME.PLO4PLO5);
    }

    if (_stripe) {
      return buttonStrip(() => handlerStripe(PRICE_KEY.PLO4PLO5));
    }
  }

  if (rateName === RATE_NAME.PLO4_YEAR) {
    if (paypal) {
      return buttonPaypal(RATE_NAME.PLO4_YEAR);
    }

    if (_stripe) {
      return buttonStrip(() => handlerStripe(PRICE_KEY.PLO4_YEAR));
    }
  }

  if (rateName === RATE_NAME.PLO5_YEAR) {
    if (paypal) {
      return buttonPaypal(RATE_NAME.PLO5_YEAR);
    }

    if (_stripe) {
      return buttonStrip(() => handlerStripe(PRICE_KEY.PLO5_YEAR));
    }
  }

  if (rateName === RATE_NAME.PLO4PLO5_YEAR) {
    if (paypal) {
      return buttonPaypal(RATE_NAME.PLO4PLO5_YEAR);
    }

    if (_stripe) {
      return buttonStrip(() => handlerStripe(PRICE_KEY.PLO4PLO5_YEAR));
    }
  }

  // maybe remove this
  if (rateName === RATE_NAME.BASIC) {
    if (paypal) {
      gtmPayment('35euro');
      return buttonPaypal(RATE_NAME.BASIC);
    }
    if (_stripe) {
      gtmPayment('35euro');
      return buttonStrip(() => handlerStripe(PRICE_KEY.BASIC));
    }
  }
  if (rateName === RATE_NAME.BASIC_YEAR) {
    if (paypal) {
      return buttonPaypal(RATE_NAME.BASIC_YEAR);
    }
    if (_stripe) {
      return buttonStrip(() => handlerStripe(PRICE_KEY.BASIC_YEAR));
    }
  }
  if (rateName === RATE_NAME.ADVANCED) {
    if (paypal) {
      gtmPayment('45euro');
      return buttonPaypal(RATE_NAME.ADVANCED);
    }
    if (_stripe) {
      gtmPayment('45euro');
      return buttonStrip(() => handlerStripe(PRICE_KEY.ADVANCED));
    }
  }
  if (rateName === RATE_NAME.ADVANCED_YEAR) {
    if (paypal) {
      return buttonPaypal(RATE_NAME.ADVANCED_YEAR);
    }
    if (_stripe) {
      return buttonStrip(() => handlerStripe(PRICE_KEY.ADVANCED_YEAR));
    }
  }
  if (rateName === RATE_NAME.ADVANCED_TRIAL) {
    if (paypal) {
      gtmPayment('checkout');
      return buttonPaypal(RATE_NAME.ADVANCED_TRIAL);
    }
    if (_stripe) {
      gtmPayment('checkout');
      return buttonStrip(() => handlerStripe(PRICE_KEY.ADVANCED_TRIAL));
    }
  }
  return <div />;
};
